import { render, staticRenderFns } from "./CRMContacts.vue?vue&type=template&id=a1135dda&scoped=true&"
import script from "./CRMContacts.vue?vue&type=script&lang=js&"
export * from "./CRMContacts.vue?vue&type=script&lang=js&"
import style0 from "./CRMContacts.vue?vue&type=style&index=0&id=a1135dda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1135dda",
  null
  
)

export default component.exports